import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

const Footer = () => {
  const mapContainerRef = useRef(null);
  const [shouldLoadMap, setShouldLoadMap] = useState(false);

  useEffect(() => {
    const mapNode = mapContainerRef.current;
    if (!mapNode) return undefined;

    if (!("IntersectionObserver" in window)) {
      setShouldLoadMap(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          setShouldLoadMap(true);
          observer.disconnect();
        }
      },
      { root: null, rootMargin: "350px 0px", threshold: 0.01 }
    );

    observer.observe(mapNode);

    return () => observer.disconnect();
  }, []);

  return (
    <footer className="site-footer" id="contact">
      <div className="container footer-grid">
        <div className="footer-col footer-map-col">
          <h3>Find Us On Map</h3>
          <div
            className="footer-map"
            aria-label="Office location map"
            ref={mapContainerRef}
          >
            {shouldLoadMap ? (
              <iframe
                title="Shankarshan Technologies office location"
                src="https://maps.google.com/maps?q=23.557895870655607,87.27918588196157&z=17&output=embed"
                width="100%"
                height="100%"
                frameBorder="0"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            ) : (
              <div className="footer-map-placeholder" aria-hidden="true">
                <span>Loading map...</span>
              </div>
            )}
          </div>
        </div>

        <div className="footer-col">
          <h3>Pages & Services</h3>
          <ul>
            <li>
              <Link to="/services/sms">SMS Solutions</Link>
            </li>
            <li>
              <Link to="/services/voice">Voice Solutions</Link>
            </li>
            <li>
              <Link to="/services/ivr">IVR Solutions</Link>
            </li>
            <li>
              <Link to="/services/WhatsAppApi">WhatsApp API & chatbot</Link>
            </li>
            <li>
              <Link to="/services/missed-call">Missed Call Service</Link>
            </li>
            <li>
              <Link to="/services/stockbroker">Stockbroker Software</Link>
            </li>
            <li>
              <Link to="/services/real-estate">Real Estate Tracking</Link>
            </li>
            <li>
              <Link to="/privacy-policy">Privacy Policy</Link>
            </li>
          </ul>
        </div>
        <div className="footer-col">
          <h3>Contact Us</h3>

          <ul className="contact-list">
            <li>
              Shankarshan Technologies Pvt Ltd, Benachity, Durgapur,
              West Bengal 713213
            </li>
            <li>
              <a href="tel:+918800418585">+91 8800418585</a>
            </li>
            <li>
              <a href="mailto:info@shankarshan.com">info@shankarshan.com</a>
            </li>
          </ul>

          <div className="footer-social">
            <h4>Follow Us</h4>

            <div className="social-icons">
              <a
                href="https://www.facebook.com/share/17HCPM22aD/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          <p>©2026 Shankarshan Technologies all rights reserved.</p>
          <p>
            <Link to="/privacy-policy" className="footer-privacy-link">
              Privacy Policy
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
